import React from 'react'
import { Accordion, AccordionItem, Grid } from '@mantine/core'
import { Company } from '../schemas/Company'

type CompanyBoxProps = {
  company: Company
  aside?: boolean
  collpase?: boolean
}

const CompanyDetail = ({ company, colspan }: { company: Company; colspan: number }) => {
  return (
    <Grid>
      <Grid.Col span={colspan}>
        {[
          {
            label: 'Name',
            value: company.name,
          },
          {
            label: 'Website',
            value: company.website,
          },
          {
            label: 'Street Address',
            value: company.streetAddress,
          },
          {
            label: 'Street Address 2',
            value: company.streetAddressTwo,
          },
          {
            label: 'City',
            value: company.city,
          },
          {
            label: 'State',
            value: company.state,
          },
          {
            label: 'Country',
            value: company.country,
          },
        ].map((item, index) =>
          item.value ? (
            <div key={index} className='d-flex mb-3 me-15'>
              <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
              <span className='flex-grow-1 fw-bold'>{item.value}</span>
            </div>
          ) : (
            <></>
          )
        )}
      </Grid.Col>
      <Grid.Col span={colspan}>
        {[
          {
            label: 'Phone',
            value: company.phone,
          },
          {
            label: 'LinkedIn',
            value: company.linkedin,
          },
          {
            label: 'Employee Range',
            value: company.employeeRange,
          },
          {
            label: 'Revenue Range',
            value: company.revenueRange,
          },
          {
            label: 'Industry',
            value: company.industry,
          },
        ].map((item, index) =>
          item.value ? (
            <div key={index} className='d-flex mb-3 me-10'>
              <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
              <span className='flex-grow-1 fw-bold'>{item.value}</span>
            </div>
          ) : (
            <></>
          )
        )}
      </Grid.Col>
    </Grid>
  )
}

export const CompanyBox: React.FC<CompanyBoxProps> = (props: CompanyBoxProps) => {
  const { company, aside = false, collpase = true } = props
  const colspan = aside ? 6 : 12
  return (
    <div className={collpase ? '' : 'card p-10'}>
      <Accordion chevronPosition='left' defaultValue='1'>
        <AccordionItem value='1'>
          <Accordion.Control>
            <h3>{company.name}</h3>
          </Accordion.Control>
          <Accordion.Panel>
            <CompanyDetail company={company} colspan={colspan} />
          </Accordion.Panel>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
